<template>
<v-dialog v-model="dialog" scrollable max-width="980px" transition="dialog-transition" :fullscreen="$vuetify.breakpoint.smAndDown" persistent @keydown.esc="emitExit()">
    <v-card flat class="hotel-modal" id="hotel-contact">
        <v-card-title primary-title>
            <div class="hotel-modal-header pl-2">
                {{ $t('hotel.modal.contact.title') }}
            </div>
            <v-spacer></v-spacer>
            <v-icon @click="emitExit()">close</v-icon>
        </v-card-title>
        <v-card-text class="scroll-card">
            <div class="hotel-modal-title pt-2">{{ $t('hotel.contact.title') }}</div>
            <v-form v-model="valid" ref="hotel_contact">

                <v-row>
                    <v-col cols="12" md="5" class="py-0">
                        <v-text-field :label="$t('hotel.contact.website')" v-model="item.static.defaults.website" />
                    </v-col>
                    <v-col cols="12" md="5" class="py-0">
                        <v-text-field :label="$t('hotel.contact.email')" v-model="item.email" required :rules="rules.email" />
                    </v-col>
                    <v-col cols="12" md="5" class="py-0">
                        <v-text-field :label="$t('hotel.contact.phone')" v-model="item.static.defaults.phone" required :rules="rules.phone" />
                    </v-col>
                    <v-col cols="12" md="5" class="py-0">
                        <v-text-field :label="$t('hotel.contact.fax')" v-model="item.static.defaults.fax" />
                    </v-col>
                </v-row>

                <v-divider class="mb-3" />
                <div>
                    <div class="d-flex fill-height align-center justify-space-between">
                        <div class="hotel-modal-title">{{$t('hotel.contact.title_contact_person')}}</div>
                    </div>
                    <v-row wrap>
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_name')" v-model="item.static.contact.person" required :rules="rules.name" />
                        </v-col>
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_email')" v-model="item.static.contact.email" required :rules="rules.email" />
                        </v-col>
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_position')" v-model="item.static.contact.position" />
                        </v-col>
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field :label="$t('hotel.contact.person_phone')" v-model="item.static.contact.phone" required :rules="rules.phone" />
                        </v-col>
                    </v-row>

                </div>
            </v-form>

        </v-card-text>
        <v-card-actions>
            <v-btn color="primary" @click="emitExit()">{{ $t('button.cancel') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" :loading="loading_save" @click="save()">{{ $t('button.save') }}</v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        dialog: Boolean,
        item: Object,
        config: Object
    },
    name: `hotel-contact`,
    components: {},
    data() {
        return {
            valid: false,
            loading_save: false,
        };
    },

    computed: {
        rules() {
            return {
                name: [v => !!v || this.$t('hotel.contact.form_rules.name')],
                phone: [v => !!v || this.$t('hotel.contact.form_rules.phone')],
                email: [
                    v => !!v || this.$t('hotel.contact.form_rules.email'),
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t('hotel.contact.form_rules.email_valid')
                ]
            }
        }
    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        save() {
            this.loading_save = true;
            // prepare some data for saving
            let model = {
                email: this.item.email,
                static: {
                    defaults: {
                        website: this.item.static.defaults.website,
                        phone: this.item.static.defaults.phone,
                        fax: this.item.static.defaults.fax
                    },
                    contact: {
                        person: this.item.static.contact.person,
                        email: this.item.static.contact.email,
                        position: this.item.static.contact.position,
                        phone: this.item.static.contact.phone
                    }
                }
            };
            let hotel = this.$clone(this.item);
            delete hotel.address;
            hotel.static.images = [];
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/console/v1/hotels/";

            this.$axios.put(endpoint + this.item.id, hotel)
                .then(response => {
                    this.$emit('update')
                })
                .catch(error => {
                    this.error("Oops, something went wrong!");
                })
                .finally(() => {
                    this.loading_save = false;
                });
        },

        emitExit() {
            this.$emit('exit')
        }
    },

};
</script>

<style lang="stylus">
.weekend-days .v-btn
    min-width: 55px
</style>
